export default __webpack_public_path__ + "static/media/transparent.55a9efc5.svg";